var ICON_NAME = /* @__PURE__ */ ((ICON_NAME2) => {
  ICON_NAME2["MicOn"] = "mic-on";
  ICON_NAME2["MicOff"] = "mic-off";
  ICON_NAME2["MicOffDisabled"] = "mic-off-gray";
  ICON_NAME2["CameraOn"] = "camera-on";
  ICON_NAME2["CameraOff"] = "camera-off";
  ICON_NAME2["CameraOffDisabled"] = "camera-off-gray";
  ICON_NAME2["ArrowBorderDown"] = "arrow-border-down";
  ICON_NAME2["ScreenSharing"] = "screen-sharing";
  ICON_NAME2["ScreenShare"] = "screen-share";
  ICON_NAME2["ScreenShareStopped"] = "screen-share-stopped";
  ICON_NAME2["ScreenShareDisabled"] = "screen-share-disabled";
  ICON_NAME2["ChatActive"] = "chat-active";
  ICON_NAME2["Chat"] = "chat";
  ICON_NAME2["ExitFullScreen"] = "exit-fullscreen";
  ICON_NAME2["FullScreen"] = "full-screen";
  ICON_NAME2["InviteActive"] = "invite-active";
  ICON_NAME2["Invite"] = "invite";
  ICON_NAME2["ManageMemberActive"] = "manage-member-active";
  ICON_NAME2["ManageMember"] = "manage-member";
  ICON_NAME2["More"] = "more";
  ICON_NAME2["MoreActive"] = "more-active";
  ICON_NAME2["SettingActive"] = "setting-active";
  ICON_NAME2["Setting"] = "setting";
  ICON_NAME2["LineArrowUp"] = "line-arrow-up";
  ICON_NAME2["LineArrowDown"] = "line-arrow-down";
  ICON_NAME2["ApplyOnSeat"] = "apply";
  ICON_NAME2["ApplyActive"] = "apply-active";
  ICON_NAME2["GoOffSeat"] = "go-off-seat";
  return ICON_NAME2;
})(ICON_NAME || {});
export {
  ICON_NAME
};
